define(["exports", "react", "react-intl-universal", "styled-components", "moment", "../../atoms"], function (_exports, _react, _reactIntlUniversal, _styledComponents, _moment, _atoms) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _moment = _interopRequireDefault(_moment);

  var ProfessionalHeader = _styledComponents.default.div.withConfig({
    displayName: "HeaderProfessional__ProfessionalHeader",
    componentId: "sc-108wuzl-0"
  })(["display:flex;padding:24px;position:relative;width:100%;@media print{padding-bottom:0;}> div:first-of-type{margin:0 16px 0 0;}h1{margin:0;}"]);

  var ProfessionalName = (0, _styledComponents.default)(_atoms.H1).withConfig({
    displayName: "HeaderProfessional__ProfessionalName",
    componentId: "sc-108wuzl-1"
  })(["span{color:", ";font-size:0.7em;font-weight:", ";}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.darkGray;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.font.regular;
  });

  var ItensOnlyForPrint = _styledComponents.default.div.withConfig({
    displayName: "HeaderProfessional__ItensOnlyForPrint",
    componentId: "sc-108wuzl-2"
  })(["display:none;font-size:1.4em;line-height:20px;@media print{display:inline-block;}"]);

  var Update = (0, _styledComponents.default)(_atoms.P).withConfig({
    displayName: "HeaderProfessional__Update",
    componentId: "sc-108wuzl-3"
  })(["color:", ";font-size:1.4em;line-height:20px;margin:0;position:absolute;right:24px;top:24px;@media print{display:none;}span{display:block;}"], function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.darkGray;
  });

  var PrintWrapper = _styledComponents.default.div.withConfig({
    displayName: "HeaderProfessional__PrintWrapper",
    componentId: "sc-108wuzl-4"
  })(["@media print{margin-left:-80px;margin-top:26px;padding:0;}"]);

  var BoldName = _styledComponents.default.span.withConfig({
    displayName: "HeaderProfessional__BoldName",
    componentId: "sc-108wuzl-5"
  })(["font-weight:", ";"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.font.semibold;
  });

  var HeaderProfessional = function HeaderProfessional(_ref5) {
    var img = _ref5.img,
        name = _ref5.name,
        email = _ref5.email,
        phone = _ref5.phone,
        position = _ref5.position,
        company = _ref5.company,
        currentCurrency = _ref5.currentCurrency,
        currentSalary = _ref5.currentSalary,
        intendedSalary = _ref5.intendedSalary,
        intendedCurrency = _ref5.intendedCurrency,
        schoolCourse = _ref5.schoolCourse,
        schoolName = _ref5.schoolName,
        educationLevel = _ref5.educationLevel,
        age = _ref5.age,
        update = _ref5.update,
        address = _ref5.address,
        labels = _ref5.labels,
        currentLocale = _ref5.currentLocale;

    var getSalary = function getSalary(salary, currency, type) {
      var translated = salary && currency && type ? _reactIntlUniversal.default.get("CURRICULUM.HEADER_PROFISSIONAL.SALARIO." + type) : '';
      var value = salary && currency ? salary.toLocaleString(currentLocale, {
        style: 'currency',
        currency: currency
      }) : '';
      return value + " " + translated;
    };

    return /*#__PURE__*/_react.default.createElement(ProfessionalHeader, null, /*#__PURE__*/_react.default.createElement(_atoms.Avatar, {
      src: img,
      kind: "image",
      name: name,
      size: "lg"
    }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: name
    }, /*#__PURE__*/_react.default.createElement(ProfessionalName, null, name, /*#__PURE__*/_react.default.createElement("span", null, ",", ' ', _reactIntlUniversal.default.get('CURRICULUM.HEADER_PROFISSIONAL.IDADE', {
      born: age
    }), ' '))), /*#__PURE__*/_react.default.createElement(ItensOnlyForPrint, null, email, phone), /*#__PURE__*/_react.default.createElement(PrintWrapper, null, /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: update
    }, /*#__PURE__*/_react.default.createElement(Update, null, /*#__PURE__*/_react.default.createElement("span", null, "Atualizado:"), (0, _moment.default)(update).format('DD/MM/YYYY'))), /*#__PURE__*/_react.default.createElement(_atoms.TextWithIcon, null, /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: position
    }, /*#__PURE__*/_react.default.createElement(_atoms.IconStyles, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "building"
    })), /*#__PURE__*/_react.default.createElement(BoldName, null, position)), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: company
    }, _reactIntlUniversal.default.get('CURRICULUM.HEADER_PROFISSIONAL.EM'), company)), /*#__PURE__*/_react.default.createElement(_atoms.TextWithIcon, null, /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: schoolCourse
    }, /*#__PURE__*/_react.default.createElement(_atoms.IconStyles, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "book"
    })), /*#__PURE__*/_react.default.createElement(BoldName, null, schoolCourse)), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: schoolName
    }, _reactIntlUniversal.default.get('CURRICULUM.HEADER_PROFISSIONAL.EM'), schoolName)), /*#__PURE__*/_react.default.createElement(_atoms.TextWithIcon, null, /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: !schoolCourse && educationLevel
    }, /*#__PURE__*/_react.default.createElement(_atoms.IconStyles, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "book"
    })), educationLevel)), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: currentSalary && currentCurrency || intendedSalary && intendedCurrency
    }, /*#__PURE__*/_react.default.createElement(_atoms.TextWithIcon, {
      wrapper: true,
      inline: true
    }, /*#__PURE__*/_react.default.createElement(_atoms.IconStyles, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "dollar-circle"
    })), getSalary(currentSalary, currentCurrency, 'ATUAL'), intendedSalary && currentSalary ? ' - ' : '', getSalary(intendedSalary, intendedCurrency, 'PRETENDIDO'))), /*#__PURE__*/_react.default.createElement(_atoms.TextWithIcon, null, /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: address
    }, /*#__PURE__*/_react.default.createElement(_atoms.IconStyles, null, /*#__PURE__*/_react.default.createElement("box-icon", {
      type: "solid",
      name: "map"
    })), /*#__PURE__*/_react.default.createElement(BoldName, null, address == null ? void 0 : address.bairro), " (", address == null ? void 0 : address.cidade, "/", address == null ? void 0 : address.estado, " - ", address == null ? void 0 : address.pais, ")")), labels && /*#__PURE__*/_react.default.createElement(_atoms.LabelRows, null, labels.map(function (label, index) {
      return /*#__PURE__*/_react.default.createElement(_atoms.Label, {
        key: index
      }, label.valor || label.value, label, /*#__PURE__*/_react.default.createElement(_atoms.Spacing, {
        horizontal: true
      }));
    })))));
  };

  var _default = HeaderProfessional;
  _exports.default = _default;
});